<template>
  <div class="picker-box">
    <div>
      <el-tabs
        v-model="editableTabsValue"
        type="border-card"
        @tab-click="handleClick"
      >
        <el-tab-pane label="买手组" name="picker_group"></el-tab-pane>
        <el-tab-pane label="人员管理" name="picker_group_member"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="editableTabsValue == 'picker_group'">
      <picker></picker>
    </div>
    <div v-if="editableTabsValue == 'picker_group_member'">
      <member></member>
    </div>
  </div>
</template>

<script>
import Picker from "./Picker";
import Member from "./Member";
export default {
  components: {
    Picker,
    Member,
  },
  data() {
    return {
      editableTabsValue: "picker_group",
    };
  },
  mounted() {
    let tab = { name: "picker_group" };
    this.handleClick(tab);
  },
  methods: {
    handleClick(tab) {
      this.editableTabsValue = tab.name;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/picker/PickerList.vue